export const messages = {
  authContinueHeader: {
    id: 'authContinueHeader',
    defaultMessage: 'Welcome Back!',
    fr: 'Bon retour!',
    description: 'Continue in App Header',
  },
  authContinueApp: {
    id: 'authContinueApp',
    defaultMessage: 'Open the App',
    fr: "Ouvrir l'appli",
    description: 'Open the App button text',
  },
  visuallyHiddenOpenInAppOrBrowser: {
    id: 'visuallyHiddenOpenInAppOrBrowser',
    defaultMessage:
      'Please click the Open The App button to proceed to the mobile app. If you want to continue to the website, click the Continue on the Website button. This will trigger another login code for you to log in to the website with.',
    fr: 'Veuillez cliquer sur le bouton Ouvrir l’appli pour accéder à l’application mobile. Si vous voulez accéder au site Web, cliquez sur le bouton Continuer sur le site Web. Cela enverra un autre code d’ouverture de session que vous pourrez utiliser pour accéder au site Web.',
    description: 'Hidden text asking the user to continue in app or web',
  },
};
